import {remCalc} from '../../_utils'

const getStyles = () => {
    return {
        flexContainer: {
            display: 'flex',
            layerStyle: 'page',
            width: '100%',
            paddingY: {base: 'medium.base', md: 'medium.md', lg: 'medium.lg', xl: 'medium.xl'},
            flexDirection: 'column',
            alignItems: 'center',
            gap: {base: 'medium-3.base', md: 'medium-3.md', lg: 'medium-3.lg', xl: 'medium-3.xl'},
        },
        headerContainer: {
            flexDirection: 'column',
            alignItems: 'flex-start',
            textAlign: 'left',
            gap: {base: 'xxxsmall.base', md: 'xxxsmall.md', lg: 'xxxsmall.lg', xl: 'xxxsmall.xl'},
            width: '100%',
        },
        title: {
            fontFamily: 'heading',
            textStyle: 'head-large',
            fontWeight: 'light',
            color: 'foreground.neutral.default',
        },
        description: {
            fontFamily: 'heading',
            textStyle: 'head-large',
            fontWeight: 'light',
            color: 'foreground.neutral.subtle',
        },
        awardsContainer: {
            display: 'grid',
            gridTemplateColumns: {
                base: 'repeat(2, 1fr)',
                md: 'repeat(2, 1fr)',
                lg: 'repeat(4, 1fr)',
                xl: 'repeat(4, 1fr)',
            },
            width: '100%',
            rowGap: {
                base: 'medium-1.base',
                md: 'medium-1.md',
                lg: 'medium-1.lg',
                xl: 'medium-1.xl',
            },
            columnGap: {base: 'small-1.base', md: 'small-1.md', lg: 'small-1.lg', xl: 'small-1.xl'},
        },
        award: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
        },
        awardContent: {
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            alignItems: 'center',
            gap: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
        },
        image: {
            boxSize: remCalc(72),
            borderRadius: 'medium-1',
            alignSelf: 'stretch',
            backgroundBlendMode: 'multiply',
            backgroundColor: [
                'background.light',
                'background.light',
                'background.light',
                'background.light',
            ],
        },
        awardTitle: {
            alignSelf: 'stretch',
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
            textAlign: 'left',
            fontWeight: 'medium',
        },
        awardDescription: {
            alignSelf: 'stretch',
            textStyle: 'body-small',
            color: 'foreground.neutral.muted',
            textAlign: 'left',
            fontWeight: 'normal',
        },
        divider: {
            display: {base: 'none', md: 'none', lg: 'block', xl: 'block'},
            borderColor: 'border.neutral.subtle',
            orientation: 'vertical',
            height: '100%',
            opacity: 1,
        },
    }
}

export default {
    baseStyle: getStyles,
}
